import { useMemo } from "react";
import { parse } from "qs";
import { useLocation } from "react-router-dom";

export const useUrlParamEnabled = (paramName: string): boolean => {
  const location = useLocation();

  return useMemo(() => {
    const queryParams = parse(location.search, { ignoreQueryPrefix: true });
    return queryParams[paramName] === "true";
  }, [location.search, paramName]);
};
